import { useAppSelector } from "@hypexone/uicore";
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaRegCalendarAlt } from "react-icons/fa";

interface CommonDatePickerProps {
  InOnChange: any;
  InValue: any;
  FromValue: any;
  FromOnChange: any;
}

const CommonDatePicker: React.FC<CommonDatePickerProps> = ({
  FromValue,
  InValue,
  FromOnChange,
  InOnChange,
}) => {
  const { langData } = useAppSelector((state) => state.cms);

  const minFromDate = InValue
    ? new Date(new Date(InValue).setMonth(new Date(InValue).getMonth() - 1))
    : new Date(new Date().setMonth(new Date().getMonth() - 1));

  return (
    <div className="flex font-helvetica text-[10px] items-center md:gap-5 gap-2 flex-row w-full">
      {/* From Date */}
      <div className="flex flex-col flex-1 min-w-0">
        <label htmlFor="from-date" className="mb-1">
          FROM DATE
        </label>
        <div className="flex items-center relative w-full">
          <DatePicker
            id="from-date"
            selected={FromValue}
            onChange={FromOnChange}
            minDate={minFromDate}
            maxDate={new Date()}
            dateFormat="yyyy-MM-dd"
            wrapperClassName="w-full"
            className="appearance-none border text-base rounded h-8 w-full pl-2 pr-9 border-gray-400 shadow-sm"
          />
          {/* Icon wrapper with full height + center */}
          <div className="absolute md:right-4 right-4 top-0 bottom-0 flex items-center pointer-events-none">
            <FaRegCalendarAlt className="text-gray-500 text-lg" />
          </div>
        </div>
      </div>

      {/* To Date */}
      <div className="flex flex-col flex-1 min-w-0">
        <label htmlFor="to-date" className="mb-1">
          TO DATE
        </label>
        <div className="relative w-full">
          <DatePicker
            id="to-date"
            selected={InValue}
            onChange={InOnChange}
            minDate={FromValue || undefined}
            maxDate={new Date()}
            dateFormat="yyyy-MM-dd"
            wrapperClassName="w-full"
            className="appearance-none border text-base rounded h-8 w-full pl-2 pr-9 border-gray-400 shadow-sm"
          />
          {/* Same icon wrapper here */}
          <div className="absolute md:right-4 right-4 top-0 bottom-0 flex items-center pointer-events-none">
            <FaRegCalendarAlt className="text-gray-500 text-lg" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonDatePicker;
